import { OptionUIState } from '../_models/state/optionUIState';

export const optionsUI: OptionUIState = {
  routingType: [
    {
      display: 'Practical',
      value: 0,
    },
    {
      display: 'Shortest',
      value: 1,
    },
    {
      display: 'Fastest',
      value: 2,
    },
  ],
  hazmat: [
    {
      display: 'None',
      value: 0,
    },
    {
      display: 'Corrosive',
      value: 2,
    },
    {
      display: 'Explosives',
      value: 3,
    },
    {
      display: 'Flammable',
      value: 4,
    },
    {
      display: 'Inhalants',
      value: 5,
    },
    {
      display: 'Radioactive',
      value: 6,
    },
    {
      display: 'Other',
      value: 1,
    },
  ],
  sideOfStreetAdherence: [
    {
      display: 'Off',
      value: 0,
    },
    {
      display: 'Minimal',
      value: 1,
    },
    {
      display: 'Moderate',
      value: 2,
    },
    {
      display: 'Average',
      value: 3,
    },
    {
      display: 'Strict',
      value: 4,
    },
    {
      display: 'Adhere',
      value: 5,
    },
    {
      display: 'Strongly Adhere',
      value: 6,
    },
  ],
  vehicleType: [
    {
      display: 'Truck',
      value: 0,
    },
    {
      display: 'Light Truck',
      value: 1,
    },
    {
      display: 'Car',
      value: 2,
    },
  ],
  daydatetype: [
    {
      display: 'Specific Day',
      value: 'weekday',
    },
    {
      display: 'Specific Date',
      value: 'date',
    },
  ],
  arrDepTypes: [
    {
      display: 'None',
      value: 'None',
    },
    {
      display: 'Depart Now',
      value: 'Now',
    },
    {
      display: 'Departure Time',
      value: 'Depart',
    },
    {
      display: 'Arrival Time',
      value: 'Arrive',
    },
  ],
  weightUnits: [
    {
      display: 'Pound',
      value: 0,
      symbol: 'lbs',
    },
    {
      display: 'Kilogram',
      value: 1,
      symbol: 'kgs',
    },
  ],
  distanceUnits: [
    {
      display: 'Mile',
      value: 0,
      symbol: 'mi',
    },
    {
      display: 'Kilometer',
      value: 1,
      symbol: 'km',
    },
  ],
  fuelUnits: [
    {
      display: 'Gallon',
      label: 'Gallons',
      value: 0,
      symbol: 'gallon',
    },
    {
      display: 'Liter',
      label: 'Liters',
      value: 1,
      symbol: 'liter',
    },
  ],
  trkUnits: [
    {
      displayNA: 'US Customary',
      displayEU: 'English',
      value: 0,
    },
    {
      displayNA: 'Metric',
      displayEU: 'Metric',
      value: 1,
    },
  ],
  tollCurrency: [
    {
      display: 'US Dollars',
      value: 0,
      exchangeRate: 1.051,
      symbol: '$',
      isPrefix: true,
    },
    {
      display: 'Canadian Dollars',
      value: 1,
      exchangeRate: 0.951,
      symbol: '$',
      isPrefix: true,
    },
  ],
  tollCurrencyEU: [
    {
      display: 'Albanian lek',
      value: 2,
      exchangeRate: 1,
      symbol: 'Lek',
      isPrefix: false,
    },
    {
      display: 'Aremenian dram',
      value: 3,
      exchangeRate: 1,
      symbol: '֏',
      isPrefix: true,
    },
    {
      display: 'Azerbaijani manat',
      value: 4,
      exchangeRate: 1,
      symbol: '₼',
      isPrefix: true,
    },
    {
      display: 'Bosnia and Herzegovina convertible mark',
      value: 5,
      exchangeRate: 1,
      symbol: 'marks',
      isPrefix: false,
    },
    {
      display: 'Bulgarian lev',
      value: 6,
      exchangeRate: 1,
      symbol: 'лв.',
      isPrefix: true,
    },
    {
      display: 'Belarusian ruble',
      value: 7,
      exchangeRate: 1,
      symbol: 'rubles',
      isPrefix: false,
    },
    {
      display: 'Swiss franc',
      value: 8,
      exchangeRate: 1,
      symbol: 'Fr.',
      isPrefix: true,
    },
    {
      display: 'Czech koruna',
      value: 9,
      exchangeRate: 1,
      symbol: 'Kč',
      isPrefix: false,
    },
    {
      display: 'Danish krone',
      value: 10,
      exchangeRate: 1,
      symbol: 'kr.',
      isPrefix: true,
    },
    {
      display: 'Euros',
      value: 11,
      exchangeRate: 1,
      symbol: '€',
      isPrefix: true,
    },
    {
      display: 'Pound sterling',
      value: 12,
      exchangeRate: 1,
      symbol: '£',
      isPrefix: true,
    },
    {
      display: 'Georgian lari',
      value: 13,
      exchangeRate: 1,
      symbol: 'GEL',
      isPrefix: true,
    },
    {
      display: 'Croatian kuna',
      value: 14,
      exchangeRate: 1,
      symbol: 'kn',
      isPrefix: false,
    },
    {
      display: 'Hungarian forint',
      value: 15,
      exchangeRate: 1,
      symbol: 'Ft',
      isPrefix: false,
    },
    {
      display: 'Icelandic króna: second króna',
      value: 16,
      exchangeRate: 1,
      symbol: 'kr',
      isPrefix: true,
    },
    {
      display: 'Moldovan leu',
      value: 17,
      exchangeRate: 1,
      symbol: 'lei',
      isPrefix: false,
    },
    {
      display: 'Second Macedonian denar',
      value: 18,
      exchangeRate: 1,
      symbol: '	ден',
      isPrefix: true,
    },
    {
      display: 'Norwegian krone',
      value: 19,
      exchangeRate: 1,
      symbol: 'kr',
      isPrefix: true,
    },
    {
      display: 'Polish złoty',
      value: 20,
      exchangeRate: 1,
      symbol: 'zł',
      isPrefix: true,
    },
    {
      display: 'Fourth Romanian leu',
      value: 21,
      exchangeRate: 1,
      symbol: 'leu',
      isPrefix: false,
    },
    {
      display: 'Serbian dinar',
      value: 22,
      exchangeRate: 1,
      symbol: 'din',
      isPrefix: false,
    },
    {
      display: 'Russian ruble',
      value: 23,
      exchangeRate: 1,
      symbol: '₽',
      isPrefix: false,
    },
    {
      display: 'Swedish krona',
      value: 24,
      exchangeRate: 1,
      symbol: 'kr',
      isPrefix: true,
    },
    {
      display: 'Turkish lira',
      value: 25,
      exchangeRate: 1,
      symbol: '₺',
      isPrefix: true,
    },
    {
      display: 'Ukrainian hryvnia',
      value: 26,
      exchangeRate: 1,
      symbol: '₴',
      isPrefix: true,
    },
  ],
};
